import { Link } from 'react-router-dom';
import './cpg.scss';

export default function CPGKeyMotivator() {
  return (
    <>
      <h5>Mail Formats for CPG Companies</h5>
      <p>CPG businesses are the most likely to use brochures or booklets in their direct mail campaigns.</p>

      <ul>
        <li>Our direct mail tutorial can help you <a href="/../dm-101-tutorial/chapter_4#subsection3">decide on the ideal format</a> for your next mail campaign.</li>
      </ul>
    </>
  );
}
